import script from "./CheckinsTemplatesTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckinsTemplatesTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./CheckinsTemplatesTableLoader.vue?vue&type=style&index=0&id=f8236100&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8236100"]])

export default __exports__